/**
 * LeaseFlow logo — shield with a house inside, drawn in teal on dark backgrounds.
 * Premium look: deep-navy shield base, teal house with subtle inner highlight.
 */
export function LeaseFlowMark({ size = 32, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="lf-shield" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#0E1C33" />
          <stop offset="100%" stopColor="#04101A" />
        </linearGradient>
        <linearGradient id="lf-house" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#00E3B7" />
          <stop offset="100%" stopColor="#00B894" />
        </linearGradient>
      </defs>
      {/* Shield base */}
      <path
        d="M20 2L34 7v12c0 8.5-5.8 16.2-14 19-8.2-2.8-14-10.5-14-19V7L20 2z"
        fill="url(#lf-shield)"
        stroke="#00D4AA"
        strokeOpacity="0.45"
        strokeWidth="1.1"
      />
      {/* House roof */}
      <path
        d="M12.6 19.4l7.4-5.8 7.4 5.8v0.6h-1.5V20.1H14.1v-0.1h-1.5v-0.6z"
        fill="url(#lf-house)"
      />
      {/* House body */}
      <rect x="14.1" y="20.1" width="11.8" height="7.4" fill="url(#lf-house)" opacity="0.95" />
      {/* Door */}
      <rect x="18.3" y="22.7" width="3.4" height="4.8" fill="#04101A" />
      {/* Windows */}
      <rect x="15.4" y="22" width="1.8" height="1.8" fill="#04101A" opacity="0.8" />
      <rect x="22.8" y="22" width="1.8" height="1.8" fill="#04101A" opacity="0.8" />
    </svg>
  );
}

export function LeaseFlowWordmark({ className = "", size = 32 }) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <LeaseFlowMark size={size} />
      <span className="font-display text-[19px] font-semibold tracking-tight text-white">
        Lease<span style={{ color: "#00D4AA" }}>Flow</span>
      </span>
    </span>
  );
}

export default LeaseFlowMark;
